import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Icona } from '@/components/Icona';

export function Carregant() {
  const { t } = useTranslation('comu');
  return (
    <div className="centre" role="status">
      <span className="dim">{t('sessio.carregant')}</span>
    </div>
  );
}

export function SensePermis() {
  const { t } = useTranslation('comu');
  return (
    <div className="empty" data-screen="403">
      <Icona nom="lock" />
      <h2>{t('estatPagina.senseAccesTitol')}</h2>
      <p>{t('estatPagina.senseAccesText')}</p>
      <Link className="btn btn--s" to="/">
        {t('estatPagina.tornaInici')}
      </Link>
    </div>
  );
}

export function NoTrobat() {
  const { t } = useTranslation('comu');
  return (
    <div className="empty" data-screen="404">
      <Icona nom="questionmark-circle" />
      <h2>{t('estatPagina.noTrobatTitol')}</h2>
      <p>{t('estatPagina.noTrobatText')}</p>
      <Link className="btn btn--s" to="/">
        {t('estatPagina.tornaInici')}
      </Link>
    </div>
  );
}

export function ErrorCarrega({
  onReintenta,
  onSurt,
}: {
  onReintenta: () => void;
  /** Si s'informa, mostra el botó per tancar la sessió o canviar de compte. */
  onSurt?: () => void;
}) {
  const { t } = useTranslation('comu');
  return (
    <div className="centre">
      <div className="estat-error">
        <Icona nom="exclamationmark-triangle" />
        <h2>{t('estatPagina.errorTitol')}</h2>
        <p className="dim">{t('estatPagina.errorText')}</p>
        <div className="row" style={{ justifyContent: 'center' }}>
          <button type="button" className="btn btn--primary btn--s" onClick={onReintenta}>
            <Icona nom="arrow-clockwise" />
            {t('estatPagina.reintenta')}
          </button>
          {onSurt ? (
            <button type="button" className="btn btn--s" onClick={onSurt}>
              <Icona nom="logout" />
              {t('sessio.canviaCompte')}
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
}
